<template>
  <div>
    <div v-if="Object.keys(errors).length > 0" class="alert alert-danger">
      <p v-for="error in errors" class="errors">
        {{ error }}
      </p>
    </div>
    <div :class="{'has-error':errors.event}">
      <select :value="event" name="event" class="form-control" @change="handleChange">
        <option value="" selected="selected">
          Select Event(s)
        </option>
        <option v-for="(name, $id) in config.events" :value="$id">
          {{ name }}
        </option>
      </select>
    </div>
    <div>
      Of the last
      <span :class="{'has-error':errors.amount || errors.lessthan}">
        <input :value="amount" name="amount" class="form-control input-numeric" @input="handleChange">
      </span>
      <select :value="ongoing" name="ongoing" class="form-control" @change="handleChange">
        <option value="true">
          Events (including in window events)
        </option>
        <option value="false">
          Events (excluding in window events)
        </option>
      </select>
      at least
      <span :class="{'has-error':errors.compliant || errors.lessthan}">
        <input :value="compliant" class="form-control input-numeric" name="compliant" @input="handleChange">
      </span>
      were compliant.
    </div>
  </div>
</template>
<script type="text/javascript">
  import BaseComponent from '@/EventLogic/components/BaseComponent.vue';

  export default {
    extends: BaseComponent,

    props: {
      compliant: [Number, String],
      event: [Number, String],
      ongoing: {
        // This is "true" or "false" as a string. The PHP code is specifically expecting a string. :-o
        type: String,
        default: "false"
      },
      amount: [Number, String],
      id: String,
    },
    methods: {
      validate: function() {
        this.errors = {};

        if (!this.isInteger(this.event)) {
          this.errors.event = 'Please select an event.';
        }

        if (!this.isInteger(this.amount) || this.amount < 1) {
          this.errors.amount = 'The number of events to look at must be a whole number (ex. 3) greater than 0.'
        }

        if (!this.isInteger(this.compliant) || this.compliant < 0) {
          this.errors.compliant = 'The number of compliant events must be a whole number (ex. 3).';
        }

        if (this.errors.amount === undefined && this.errors.compliant === undefined) {
          if (Number(this.amount) < Number(this.compliant)) {
            this.errors.lessthan = "The number of events to look at must be greater than or equal to the number of events which must be compliant.";
          }
        }

        return Object.keys(this.errors).length === 0;
      }
    }
  };
</script>
